<template>
  <div>
    <b-row>
      <b-col>
        <header-view
          class="text-uppercase"
          :title="$t('message.info.title')">
        </header-view>
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col>
       <p> 
         <a target="_blank" href="https://meine-vertraege.net">Meine-vertraege.net</a> ist ein digitaler Vertragsmanager der es Benutzern erlaubt,
         seine kompletten Vertragsverhältnisse zu erfassen und aufzulisten. Des Weiteren kann der Kontoinhaber Kontaktpersonen bestimmen, welche nach seinem Ableben Einsicht in die ihnen zugeordneten Verträge gewährt bekommen.<br>
         Der digitale Vertragsmanager wird als Assistancedienstleistung der Bestattungsvorsorgeversicherung von der 
         <a target="_blank" href="https://www.nuernberger.de/">NÜRNBERGER VERSICHERUNG</a> in Kooperation mit dem 
         <a target="_blank" href="https://www.bestatter.de/">Kuratorium Deutsche Bestattungskultur</a> angeboten.

       </p>
      </b-col>
    </b-row>
    <b-row class="mt-5">
       <b-col>
        <a target="_blank" href="https://www.nuernberger.de"><img class="n-logo" src="@/assets/Nuernberger-logo.png"/></a><br>
        <a target="_blank" href="https://www.bestatter.de/"> <img class="b-logo mt-5" src="@/assets/Bestatter-logo.png"/></a>
       </b-col>
    </b-row>
  </div>
</template>

<script>
  import HeaderView from '@/components/common/HeaderView'

  export default {
    name: 'Info',
    components: {
      HeaderView
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/info/InfoText.vue